export function slicks() {
  $('.wc-block-grid__products').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: true,
    centerPadding: '40px',
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          infinite: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // slick-slider för related products
  if($('.product-related-products').length > 0) {
    $('.product-related-products .related .products').slick({
      dots: false, // från true
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      // centerMode: true,
      // centerPadding: '40px',
    //  autoplay: true,
    //  autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: false,
            infinite: false,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


export function popover_slick_image_gallery(startSlide) {
  $('#popover-slick .gallery-container').slick( {
    dots: false,
    infinite: true,
    initialSlide: startSlide,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('#slick-btn-left'),
    nextArrow: $('#slick-btn-right'),
  })
}
